import { useEffect, useState } from 'react';
import './game-news-modal.styles.scss';
import Modal from '@/components/modal/modal.component';
import linkifyHtml from 'linkify-html';
import { format } from 'date-fns';
import { useNavigate } from 'react-router-dom';
import {
  NEWS_SNOOZE_MS,
  getActiveGameMessages,
  getMessagePostedTs,
  getNewsDismissal,
  hasNewActivation,
  setNewsDismissal
} from '@/components/SHARED/game-news/game-news.utils';

// Pops every active news item up on the player's home page, newest first.
// Hiding it snoozes the popup for NEWS_SNOOZE_MS; it comes back after that
// while any item is still active, or straight away if an item goes active
// (including one a manager switched off and back on).
const GameNewsModal = ({
  gameData,
  playerData,
  gameMessages
}) => {

  const [messagesToShow, setMessagesToShow] = useState([]);
  // bumped when a snooze runs out so the check below runs again
  const [snoozeEnded, setSnoozeEnded] = useState(0);
  const navigate = useNavigate();
  const gameId = gameData?.gameId;
  const playerId = playerData?.playerId;

  useEffect(() => {
    if (!gameId || !playerId) return;
    const active = getActiveGameMessages(gameMessages);
    if (active.length === 0) {
      setMessagesToShow([]);
      return;
    }
    const dismissal = getNewsDismissal(gameId, playerId);
    const hasUnseen = !dismissal || hasNewActivation(dismissal, active);
    const snoozeLeft = dismissal ? dismissal.ts + NEWS_SNOOZE_MS - Date.now() : 0;
    if (hasUnseen || snoozeLeft <= 0) {
      setMessagesToShow(active);
      return;
    }
    setMessagesToShow([]);
    const timeout = setTimeout(() => setSnoozeEnded(n => n + 1), snoozeLeft);
    return () => clearTimeout(timeout);
  }, [gameMessages, gameId, playerId, snoozeEnded])

  function dismiss() {
    setNewsDismissal(gameId, playerId, messagesToShow);
    setMessagesToShow([]);
    // restarts the check, which arms the timer for the end of this snooze
    setSnoozeEnded(n => n + 1);
  }

  return (
    <div className='game-news-modal'>
      <Modal
        show={messagesToShow.length > 0}
        cancel={dismiss}
        closeButton={true}
        cls='narrow'
        text='Game News' >
        {
          (messagesToShow.length > 0) &&
          <div className='game-news-modal-content'>
            <div className='news-items'>
              {
                messagesToShow.map(m => (
                  <div key={m.id} className='g-list-item news-item'>
                    {
                      (m.title) &&
                      <div className='headline'>{m.title}</div>
                    }
                    <div className='meta'>Posted {format(new Date(getMessagePostedTs(m)), "Pp")}</div>
                    <div
                      className='news-body'
                      dangerouslySetInnerHTML={{ __html: linkifyHtml(m.message ?? '', { 'target': '_blank' }) }}></div>
                  </div>
                ))
              }
            </div>
            <div className='g-space-1'></div>
            <div className='buttons'>
              <button
                className='g-button'
                onClick={() => {
                  dismiss();
                  navigate('news');
                }}>
                See All News
              </button>
              <button className='g-button primary' onClick={dismiss}>
                Got it
              </button>
            </div>
          </div>
        }
      </Modal>
    </div>
  )
}

export default GameNewsModal
